<script setup lang="ts">
const { isLoading } = useLoading()
</script>

<template>
  <div v-if="isLoading" class="loading active">
    <section>로딩중</section>
  </div>
</template>
